import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpInterceptorsProviders } from './auth/interceptors';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataArticleTableComponent } from './pages/data-article-table/data-article-table.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './layouts/base-layout/base-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareComponentModule } from './components/share.component.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NotificationComponent } from './components/notification/notification.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const materialModules = [
  FormsModule,
];


@NgModule({
  declarations: [
    AppComponent,
    BaseLayoutComponent,
    LoginLayoutComponent,
    DataArticleTableComponent,
  ],
  imports: [
    ...materialModules,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    ShareComponentModule,
    NotificationComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },

    })
  ],
  providers: [HttpInterceptorsProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }
